export default "__VITE_ASSET__CiRkEQna__"